import angular from 'angular';
import uiRouter from 'angular-ui-router';
import signupComponent from './signup.component';
import ngMessages from 'angular-messages';

let signupModule = angular.module('signup', [
    uiRouter,
    ngMessages
])

.config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $stateProvider
        .state('signup', {
            url: '/signup/{token}',
            component: 'signup',
            resolve: {
                invite: ($q, UsersService, $stateParams, $state) => {
                    return UsersService.isInviteValid({
                        token: $stateParams.token
                    }).catch(() => {
                        $state.go('login');
                        $q.reject(true);
                    });
                }
            }
        });
})
.component('signup', signupComponent)
.name;

export default signupModule;
